import { c as _c } from "react/compiler-runtime";
import { Info } from "lucide-react";
import { useIntl } from "react-intl";
import { Tooltip, TooltipContent, TooltipTrigger } from "uiShadcn/tooltip";
import { cn } from "utils/helpers/cn";
const EmailInfoTooltip = () => {
  const $ = _c(12);
  const {
    formatMessage
  } = useIntl();
  let t0;
  if ($[0] !== formatMessage) {
    t0 = formatMessage({
      id: "more_info"
    });
    $[0] = formatMessage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TooltipTrigger asChild={true}><Info className="h-4 w-4 rounded-full focus:outline-none focus:ring-2 focus:ring-ring" tabIndex={0} aria-label={t0} /></TooltipTrigger>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("w-64");
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== formatMessage) {
    t3 = formatMessage({
      id: "emailFieldTooltip"
    });
    $[5] = formatMessage;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <TooltipContent sideOffset={16} className={t2}><p>{t3}</p></TooltipContent>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <Tooltip>{t1}{t4}</Tooltip>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default EmailInfoTooltip;